import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');

@Component({
  selector: 'app-menu-items',
  templateUrl: './menu-items.component.html',
  styleUrls: ['./menu-items.component.scss']
})
export class MenuItemsComponent {

      siteVal:any;
     menuItems:Array<any>;
     menuItemsData: FirebaseListObservable<any>;
    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.menuItemsData = af.list('/menuItems');
         this.menuItemsData.subscribe((res)=>{
         this.menuItems = res;
     });
    }


      getMenuItems(ev: any) {
        let val = ev;
        console.log("value" + val.charAt(0).toUpperCase() + val.slice(1));
        this.menuItemsData = this.af.list('/menuItems', {
            query: {
                orderByChild: 'title',
                startAt: val.charAt(0).toUpperCase() + val.slice(1),
                endAt: val.charAt(0).toUpperCase() + val.slice(1) + '\uf8ff'
            }
        });
        this.menuItemsData
            .subscribe((data) => {
                this.menuItems = data;
            });


    }
  
     menuItemShow(key){
     this.router.navigate(['/menu/viewItems', key]);
  }
  
   menuItemEdit(key){
    this.router.navigate(['/menu/editItems', key]);
  }
 
   menuItemDelete(key:any){
    swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this data!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.menuItemsData.remove(key).then((res)=>{
                   swal('Deleted!','Menu Item Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/menu-items/menu-items.component.ts